/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./channel-setting.vue?vue&type=template&id=ae668ea4&scoped=true&"
import script from "./channel-setting.vue?vue&type=script&lang=ts&"
export * from "./channel-setting.vue?vue&type=script&lang=ts&"
import style0 from "./channel-setting.vue?vue&type=style&index=0&id=ae668ea4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae668ea4",
  null
  
)

export default component.exports